import React from "react";
import { Grid, Box, Chip } from "@mui/material";
import { CommonSearchbar } from "src/layouts/dashboard/Searchbar";
import PartnerCard from "./PartnerCard";
import { useList } from "src/hooks/useFetch.hook";
import { Loader } from "src/components/Loader";
import { useNavigate } from "react-router-dom";
import { useDropdown } from "src/hooks/useDropdown.hook";

const PartnerList = ({ onSync, onDelete }) => {
  const { data: partners = [], isFetching } = useList("partners");
  const { data: ocpiRoles } = useDropdown("OcpiRole");
  const { data: ocpiVersions } = useDropdown("OcpiVersion");
  const navigate = useNavigate();
  
  if (isFetching) {
    return <Loader />
  }

  const onConfigure = (id) => {
    navigate(`/ocpi/partners/onboard/${id}`);
  }

  const onView = (id) => {
    navigate("/ocpi/partner/" + id);
  }

  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Box sx={{ flex: 1 }}>
          <CommonSearchbar placeholder="Search" />
        </Box>
        <Chip
          label={`${partners.length} partners`}
          color="default"
          sx={{ fontWeight: 600, bgcolor: "grey.100", color: "grey.800" }}
        />
      </Box>
      {partners.length === 0 ? (
        <Box sx={{ textAlign: "center", py: 6, color: "grey.600" }}>
          No partners found. Please add a partner to get started.
        </Box>
      ) : (
        <Grid container spacing={3}>
          {partners.map((partner) => (
            <Grid item xs={12} sm={6} md={4} key={partner.id}>
              <PartnerCard
                data={partner}
                onView={() => onView && onView(partner.partyId)}
                onConfigure={() => onConfigure(partner.id)}
                onSync={() => onSync && onSync(partner)}
                onDelete={() => onDelete && onDelete(partner)}
                ocpiRoles={ocpiRoles}
                ocpiVersions={ocpiVersions}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default PartnerList;
